
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { ServiceAgreementsApi } from "./api";
import ServiceAgreementGrid from "./ServiceAgreementGrid";

interface serviceAgreementsWidgetProps {
  id: string;
  header: string;
}

const SearchGridWidget = (props: serviceAgreementsWidgetProps) => {
  const [serviceAgreements, updateServiceAgreements] = useState(null);
  const [serviceAgreementsLoading, updateLoadingServiceAgreements] =
    useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const globalParams = useSelector(getParamsSelector);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (globalParams.customerID != null) {
      updateLoadingServiceAgreements(true);
      getServiceAgreements(globalParams.customerID, signal);
    }
    return () => controller.abort();
  }, [globalParams.customerID]);

  const getServiceAgreements = (cId, signal) => {
    let params: any = { customerId: cId };
    ServiceAgreementsApi.getCustomerServiceAgreements(params, signal)
      .then((response: any) => {
        //console.log(response);
        updateServiceAgreements(response);
        updateLoadingServiceAgreements(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingServiceAgreements(true);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  if (serviceAgreementsLoading) {
    return <Spinner text="service agreements" />;
  }
  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  return <ServiceAgreementGrid data={serviceAgreements} />;
};

export default SearchGridWidget;
